<div class="filter-for-list">
  <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
  </mat-form-field>
  <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner===true"></app-progressbar>
<table mat-table [dataSource]="matTableDataSource" matSort class="table-striped" style="width:100%">

  <ng-container *ngFor="let column of MAIN_COLUMNS_TO_DISPLAY" [matColumnDef]="column">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column |translate}}</th>
    <td mat-cell *matCellDef="let element">
      <fa-icon class="statusNote"
               *ngIf="column === 'note'"
               [ngClass]="getClassByNote(element[column])"
               [icon]="getIconStatus(element[column])">{{element[column]}}</fa-icon>
      <div *ngIf="column !== 'note'"        [ngClass]="getClassByElementName(column)">{{element[column]}}</div>
    </td>
  </ng-container>

  <ng-container *ngFor="let column of DETAILS_COLUMNS_TO_DISPLAY" [matColumnDef]="column">
    <th mat-header-cell *matHeaderCellDef>{{ column | translate }}</th>
    <td mat-cell *matCellDef="let element">
      <app-dashboard-edas-detail [dashboardElement]="element[column]"></app-dashboard-edas-detail>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="pageSize"></mat-paginator>
